import axios from 'axios';

const request = axios.create({
  baseURL: "/",
  timeout: 10000
});

request.interceptors.request.use(config => {
  return config;
});

request.interceptors.response.use(
  resp => {
    if (resp.status !== 200) {
      return Promise.reject(resp.data);
    }
    return resp.data;
  },
  error => {
    return Promise.reject(error);
  }
);

export default request;


// WEBPACK FOOTER //
// ./src/request/index.js